










































import { editFactory } from '@/main/pages';

import { store } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store).extend({
	data() {
		return {
			showTiskDialog: false,
		};
	},
	watch: {
		Text(val) {
			this.titleDetail = val;
		},
	},
	methods: {
		tiskClicked() {
			this.showTiskDialog = true;
		},
	},
});
